import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="sm:col-span-2 lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-book-open-line text-background-50 text-lg"></i>
              </div>
              <span className="text-lg font-bold whitespace-nowrap text-foreground-950">
                女神漫画
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed">
              女神漫画网专为手机端优化，提供女神漫画下拉式在线阅读模式，流畅滚动看全集。涵盖韩漫、日漫、国漫等热门作品。
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">
              快速导航
            </h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/"
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors"
                >
                  首页
                </Link>
              </li>
              <li>
                <Link
                  to="/category/all"
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors"
                >
                  全部漫画
                </Link>
              </li>
              <li>
                <Link
                  to="/category/korean"
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors"
                >
                  韩漫专区
                </Link>
              </li>
              <li>
                <Link
                  to="/category/japanese"
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors"
                >
                  日漫专区
                </Link>
              </li>
              <li>
                <Link
                  to="/category/chinese"
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors"
                >
                  国漫专区
                </Link>
              </li>
            </ul>
          </div>

          {/* Type Links */}
          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">
              热门类型
            </h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/category/action"
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors"
                >
                  热血漫画
                </Link>
              </li>
              <li>
                <Link
                  to="/category/romance"
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors"
                >
                  恋爱漫画
                </Link>
              </li>
              <li>
                <Link
                  to="/category/fantasy"
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors"
                >
                  奇幻漫画
                </Link>
              </li>
              <li>
                <Link
                  to="/category/mystery"
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors"
                >
                  悬疑漫画
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">
              关于我们
            </h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/about"
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors"
                >
                  品牌介绍
                </Link>
              </li>
              <li>
                <span className="text-sm text-foreground-600">
                  联系邮箱：contact@nvshenmh.com
                </span>
              </li>
              <li>
                <span className="text-sm text-foreground-600">
                  客服QQ：1234567890
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-200 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {currentYear} 女神漫画网 版权所有 | 女神漫画下拉式在线阅读平台
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <span>女神漫画下拉式免费全集</span>
            <span className="hidden sm:inline">·</span>
            <span>流畅手机漫画阅读</span>
          </div>
        </div>
      </div>
    </footer>
  );
}